import { Actions } from '@ngrx/effects';
import { AppState } from '@get/store/configs/reducers';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { UserSocieteProfilApiService } from '@get/store/api-services';
import { GeneratedUserSocieteProfilEffects } from './user-societe-profil-generated.effects';

@Injectable()
export class UserSocieteProfilEffects extends GeneratedUserSocieteProfilEffects {
  constructor(actions$: Actions, userSocieteProfilApiService: UserSocieteProfilApiService, store$: Store<AppState>) {
    super(actions$, userSocieteProfilApiService, store$);
  }
}
